import 'react-sliding-pane/dist/react-sliding-pane.css';
import 'react-toastify/dist/ReactToastify.css';
import 'src/style/toop-tip/tooltip.scss';
import './App.scss';
import './index.scss';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { ConfirmContextProvider } from './contexts/ConfirmContext';
import { DialogProvider } from './contexts/DialogContext';
import LocaleContextProvider from './contexts/LocaleContext';
import reportWebVitals from './reportWebVitals';
import { queryClient } from './utils/queryClient';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <DialogProvider>
      <AuthProvider>
        <LocaleContextProvider>
          <CompanyProvider>
            <HelmetProvider>
              <BrowserRouter>
                <CookiesProvider>
                  <ConfirmContextProvider>
                    <App />
                  </ConfirmContextProvider>
                </CookiesProvider>
              </BrowserRouter>
            </HelmetProvider>
          </CompanyProvider>
        </LocaleContextProvider>
      </AuthProvider>
    </DialogProvider>
    {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

reportWebVitals();
